import React, {Component} from "react";
import phoneMock from '../../assets/unit_devices/Phone/Mock.png';
import phoneLive from '../../assets/unit_devices/Phone/Live.png';
import horizontalPhone from '../../assets/unit_devices/Phone/Horizontal.png';
import tablet from '../../assets/unit_devices/Tablet/Vertical.png';
import horizontalTablet from "../../assets/unit_devices/Tablet/Horizontal.png";
import rb from '../../assets/Roadside-Billboard_840x400@2x.png';
import chv from '../../assets/Commuter-Hub_1080x1920@2x.png';
import chh from '../../assets/Commuter-Hub_1920x1080@2x.png';
import desktop from '../../assets/unit_devices/Laptop/Laptop.png';
import CTV from '../../assets/unit_devices/ConnectedTV/CTV.png';



class ThumbnailDeviceFrame extends Component{
    constructor(props) {
        super(props);
    }
    checkThumbId = (type, id) => {
        if(type === "live" && id === 1 || type === "live"  && id === 9){
            return phoneLive
        }
        if(type === "mock" && id === 1 || type === "mock" && id === 9){
            return phoneMock
        }

        switch(id) {
            case 7:
                return horizontalPhone;
            case 10:
                return horizontalPhone;
            case 2:
                return tablet;
            case 8:
                return horizontalTablet;
            case 3:
                return desktop;
            case 11:
                return CTV;
            case 12:
                return rb;
            case 13:
                return chv;
            case 14:
                return chh;

        }

    }
    render(){
        return (
            <div>
                <img className="thumbnail" src={this.props.adImage}/>
                <img src={this.checkThumbId(this.props.unitType, this.props.thumbnailDeviceId)} className="preview-container"/>
            </div>
        );
    }
};

export default ThumbnailDeviceFrame;